import { LANGUAGES } from '../constants/storefrontOrderConstants';

/**
 * The story SKU to show for an order line. Storefront lines already carry the
 * language code in their SKU (e.g. `boy-and-animals-ar`); dashboard lines keep
 * the bare handle and store the language in the "Story Language" property, so
 * the code is appended here for display.
 */
export function getStorySkuForDisplay(line) {
  const sku = String(line?.sku || '');
  if (!sku) return '';
  const label = String(
    (Array.isArray(line?.properties) ? line.properties : [])
      .find(prop => prop?.name === 'Story Language')?.value || ''
  ).trim().toLowerCase();
  const language = LANGUAGES.find(item => item.label.toLowerCase() === label);
  if (!language || language.code === 'en' || sku.endsWith(`-${language.code}`)) {
    return sku;
  }
  return `${sku}-${language.code}`;
}
